var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { Modal } from 'semantic-ui-react';
import ConfirmModal from '../../components/confirm';
import Icon from '../icon';
import Loader from '../loader';
import Theme from '../theme.config';
import ExternalField from './external-field';
var DataSheetConfigField = function (props) {
    var defaultModalStyle = { width: '90vw',
        height: '80vh' };
    var fullScreenModalStyle = { width: '100vw',
        height: '100vh', borderRadius: '0' };
    var formData = props.formData;
    var _a = props.schema, external_url = _a.external_url, button_text = _a.button_text;
    var jsonFormData = JSON.parse(formData);
    var _b = React.useState(false), isModalOpen = _b[0], setIsModalOpen = _b[1];
    var _c = React.useState(false), isFullScreen = _c[0], setIsFullScreen = _c[1];
    var _d = React.useState(false), isConfirmOpen = _d[0], setIsConfirmOpen = _d[1];
    var dataSheetFrameRef = React.useRef(null);
    var _e = React.useState(true), isDataLoading = _e[0], setIsDataLoading = _e[1];
    var handleExternalClick = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            event.preventDefault();
            setIsModalOpen(true);
            window.addEventListener('message', onMessage);
            return [2 /*return*/];
        });
    }); };
    var onMessage = function (message) {
        var data;
        try {
            data = JSON.parse(message.data);
        }
        catch (err) {
            console.log('Error parsing data sheets post message', err);
            return;
        }
        if (data.type === 'dataSheets' && data.dataSheetsReady) {
            if (dataSheetFrameRef.current) {
                dataSheetFrameRef.current.contentWindow.postMessage(jsonFormData, external_url);
                var loadingTimeout_1 = setTimeout(function () {
                    setIsDataLoading(false);
                    clearTimeout(loadingTimeout_1);
                }, 200);
            }
        }
        else if (data.type === 'success') {
            setIsModalOpen(false);
            window.removeEventListener('message', onMessage);
            props.onChange(JSON.stringify(data.payload));
        }
    };
    var newProps = __assign(__assign({}, props), { handleExternalClick: handleExternalClick, hideCheck: true });
    var toggleFullScreen = function () {
        isFullScreen ? setIsFullScreen(false) : setIsFullScreen(true);
    };
    var closeModal = function () {
        setIsModalOpen(false);
        setIsConfirmOpen(false);
        window.removeEventListener('message', onMessage);
    };
    React.useEffect(function () {
        if (!isModalOpen) {
            setIsDataLoading(true);
            setIsFullScreen(false);
        }
    }, [isModalOpen]);
    return (React.createElement(React.Fragment, null,
        React.createElement(ExternalField, __assign({}, newProps)),
        isModalOpen ? React.createElement(Modal, { open: isModalOpen, size: "large", style: isFullScreen ? fullScreenModalStyle : defaultModalStyle },
            React.createElement("div", { style: { padding: '20px', height: '100%' } },
                React.createElement(Modal.Header, null,
                    React.createElement("div", { style: { display: 'flex', justifyContent: 'space-between', fontWeight: 'bold', fontSize: '24px', color: Theme.color.base } },
                        React.createElement("div", null,
                            React.createElement(Icon, { name: "" + (isFullScreen ? 'shrink' : 'expand'), style: { backgroundColor: Theme.color.black, marginRight: '16px', cursor: 'pointer' }, onClick: toggleFullScreen }),
                            button_text),
                        React.createElement(Icon, { name: "close", style: { backgroundColor: Theme.color.black, cursor: 'pointer' }, onClick: function () { return setIsConfirmOpen(true); } }))),
                React.createElement(Modal, { open: isConfirmOpen, size: "small" },
                    React.createElement(ConfirmModal, { confirmButton: "Discard", isDanger: true, confirm: closeModal, onCancel: function () { return setIsConfirmOpen(false); } },
                        "You are about to discard the changes made to this data sheet.",
                        React.createElement("br", null),
                        "Do you want to proceed?")),
                isDataLoading &&
                    React.createElement("div", { className: "spinnerWrapper" },
                        React.createElement(Loader, { active: true, inline: true })),
                React.createElement("iframe", { ref: dataSheetFrameRef, id: "data-sheet-frame", src: external_url, style: { width: '100%', height: 'calc(100% - 32px)', marginTop: '1%', border: 'none', overflow: 'hidden' }, allow: "clipboard-read; clipboard-write" }))) : null));
};
export default DataSheetConfigField;
//# sourceMappingURL=data-sheet-config.js.map